export interface MainMenuChild {
  key: string;
  text: string;
  link: string;
}

export interface MainMenuItem {
  key: string;
  text: string;
  link: string;
  // Paths (prefix-matched) that keep this item highlighted
  patterns: string[];
  // Optional dropdown sub-items (e.g. Norms → Material / Manpower / Machine)
  children?: MainMenuChild[];
}

// Single source of truth for the top navigation — see docs/pms-design-system.md §2.
// Dashboard, Checklists, Calendar, Rate Cards and Pending Approvals are hidden from the top
// menu (commented out below); their routes still work if navigated to directly.
export const MAIN_MENU: MainMenuItem[] = [
  // {
  //   key: "dashboard",
  //   text: "Dashboard",
  //   link: "/pms/main-dashboard",
  //   patterns: ["/pms/main-dashboard"],
  // },
  {
    key: "projects",
    text: "Projects",
    link: "/pms/projects",
    patterns: [
      "/pms/projects",
      "/pms/project",
      "/pms/active-projects",
      "/pms/draftProjects",
      "/pms/closed-projects",
      "/pms/inactive-projects",
      "/pms/archived-projects",
      "/pms/groups-projects",
      "/pms/recycle-bin",
      "/pms/project-creation",
      "/pms/expenses",
      "/pms/sequence",
    ],
  },
  // {
  //   key: "checklists",
  //   text: "Checklists",
  //   link: "/pms/Checklist/checklist-lists",
  //   patterns: ["/pms/Checklist"],
  // },
  // {
  //   key: "calendar",
  //   text: "Calendar",
  //   link: "/pms/calendar",
  //   patterns: ["/pms/calendar", "/pms/calendar-detail", "/pms/calendar-creation"],
  // },
  // {
  //   key: "ratecards",
  //   text: "Rate Cards",
  //   link: "/pms/rate-cards",
  //   patterns: ["/pms/rate-cards"],
  // },
  {
    key: "norms",
    text: "Norms",
    link: "/pms/norms",
    patterns: [
      "/pms/norms",
      "/pms/manpower-norms",
      "/pms/machinery-norms",
      "/pms/execution-norms",
    ],
    children: [
      { key: "norms-material", text: "Material", link: "/pms/norms" },
      { key: "norms-manpower", text: "Manpower", link: "/pms/manpower-norms" },
      { key: "norms-machinery", text: "Machinery", link: "/pms/machinery-norms" },
      // Per-activity execution norms: BOQ quantity produced per unit of advance.
      { key: "norms-execution", text: "Execution", link: "/pms/execution-norms" },
    ],
  },
  {
    key: "assets",
    text: "Assets",
    link: "/pms/assets",
    patterns: ["/pms/assets"],
    children: [
      { key: "assets-master", text: "Asset Master", link: "/pms/assets" },
    ],
  },
  // {
  //   key: "pending",
  //   text: "Pending Approvals",
  //   link: "/pms/pending-approvals",
  //   patterns: ["/pms/pending-approvals"],
  // },
];

export const isMenuItemActive = (pathname: string, item: MainMenuItem): boolean =>
  item.patterns.some(
    (p) => pathname === p || pathname.startsWith(p + "/")
  );
